module.exports = __webpack_public_path__ + "static/media/p2.e22945d0.png";